// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionPage_wrapper__OBg+h","buttonContainer":"SectionPage_buttonContainer__qbq35","container":"SectionPage_container__y6kX1"};